// Bridged accounts (Nostr through mostr.pub) have a key as the name part
// of their handle: 64 hex characters, or an npub. Shown whole it fills
// two lines, so the name part becomes its start and end.
const KEY = /^(?:[0-9a-f]{32,}|npub1[02-9ac-hj-np-z]{50,})$/i

const shorten = (key) => `${key.slice(0, 8)}…${key.slice(-4)}`

// "96a578f6…e93d@mostr.pub" for a key handle; any other handle as it is
export const shortHandle = (handle) => {
  if (!handle) return handle
  const at = handle.indexOf('@')
  const name = at === -1 ? handle : handle.slice(0, at)
  if (!KEY.test(name)) return handle
  return shorten(name) + (at === -1 ? '' : handle.slice(at))
}
